import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import AppSetup from "../core/AppSetup";
import { ITask } from "../interfaces/Timelog";
import { ITitle, ITitleLong } from "../interfaces/Music";
import { IMember, IThreadShort } from "../interfaces/App";

const apiUrl = AppSetup.getUserApiUrl();
axios.defaults.baseURL = apiUrl;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/json';
export const setToken = () => {
    const authToken = localStorage.getItem("AUTHTOKEN");
    // console.log("authtoken:", authToken);
    axios.defaults.headers.common.AuthToken =  authToken ? authToken : "";
}
export const getSetup = createAsyncThunk(
    "get/setup",
    async (_P: any, thunkAPI) => {
        setToken();
        try {
            return await axios.get("setup");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const createBookmarks = createAsyncThunk(
    "create/bookmarks",
    async (p: any, thunkAPI) => {
        setToken();
        // const FormData = require("form-data");
        const data = new FormData();
        data.append("uploadfile", p);
        data.append("name", p.name);
        data.append("size", p.size);
        data.append("type", p.type);
        const url = "bookmarks.json";
        try {
            return await axios.post(url, data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getBookmarks = createAsyncThunk(
    "get/bookmarks",
    async (_P: any, thunkAPI) => {
        setToken();
        const url = "bookmarks.json";
        try {
            return await axios.get(url);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const saveBookmarks = createAsyncThunk(
    "get/saveBookmarks",
    async (_P: any, thunkAPI) => {
        setToken();
        const url = "bookmarks.json";
        try {
            return await axios.get(url);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const postBookmark = createAsyncThunk(
    "post/bookmarks",
    async (param: any, thunkAPI) => {
        setToken();
        const url = "bookmarks.json?guid=" + param.guid;
        try { 
            return await axios.post(url, param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const delBookmark = createAsyncThunk(
    "del/bookmarks",
    async (param: any, thunkAPI) => {
        setToken();
        const url = "bookmarks.json?guid=" + param;
        try {
            return await axios.delete(url);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const putBookmark = createAsyncThunk(
    "put/bookmark",
    async (param: any, thunkAPI) => {
        setToken();
        const url = "bookmarks.json?guid=" + param.guid;
        try {
            return await axios.put(url, param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const loginUser = createAsyncThunk(
    "put/login",
    async (param: any, thunkAPI) => {
        if (!param) {setToken()};
        try {
            return await param?.token ? axios.put("login?" + param.token) : axios.put("login", param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const sendPass = createAsyncThunk(
    "get/sendPass",
    async (param: any, thunkAPI) => {
        try {
            return await axios.get("sendPass?email=" + param.user);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const sendConfirm = createAsyncThunk(
    "get/sendConfirm",
    async (param: any, thunkAPI) => {
        setToken();
        const path = "sendConfirm?" + (param.sms ? ("sms=" + param.sms) : ("email=" + param.email));
        try {
            return await axios.get(path);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const logout = createAsyncThunk(
    "put/logout",
    async (_: any, thunkAPI) => {
        setToken();
        // const authToken = localStorage.getItem("AUTHTOKEN");
        // axios.defaults.headers.common.AuthToken =  authToken ? authToken : "";
        try {
            return await axios.put("logout", {logout: "yes"});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const register = createAsyncThunk(
    "post/register",
    async (param: any, thunkAPI) => {
        setToken();
        try {
            return await axios.post("register", param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const resetPW = createAsyncThunk(
    "put/resetPW",
    async (param: any, thunkAPI) => {
        axios.defaults.headers.common.AuthToken = param.authToken;
        try {
            return await axios.put("resetPW", param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getVersion = createAsyncThunk(
    "get/version",
    async (param: any, thunkAPI) => {
        try {
            return await axios.get("version", param);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const makeCloudIndex = createAsyncThunk(
    "post/cloudIndex",
    async (param: any, thunkAPI) => {
        setToken();
        const data = {
            big: param.big,
            thumb: param.thumb,
            type: param.type,
        };
        try {
            return await axios.post("cloud/" + param.path, data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getCloudIndex = createAsyncThunk(
    "get/cloudIndex",
    async (path: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/" + path + "index.js");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getFile = createAsyncThunk(
    "get/file",
    async (file: {path: string, name: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/" + file.path + file.name);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const saveIndex = createAsyncThunk(
    "put/saveIndex",
    async (param: any, thunkAPI) => {
        setToken();
        try {
            return await axios.put("cloud/" + param.path, param.data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const uploadImage = createAsyncThunk(
    "post/uploadImage",
    async (p: {path: string, file: File, type: string, thumb: number, big: number, userId?: string, threadId?: number}, thunkAPI) => {
        setToken();
        const FormData = require("form-data");
        const data = new FormData();
        data.append("uploadfile", p.file);
        data.append("filename", p.file.name);
        data.append("type", p.type);
        data.append("thumb", p.thumb);
        data.append("big", p.big);
        if (p.userId) {
            data.append("user_id", p.userId);
        }
        if (p.threadId) {
            data.append("thread_id", p.threadId);
        }
        try {
            return await axios.post("cloud/" + p.path, data, {headers: {'content-type': 'multipart/form-data'}});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const deleteImage = createAsyncThunk(
    "post/deleteImage",
    async (p: {path: string, id: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.delete("cloud/" + p.path + "?id=" + p.id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getUser = createAsyncThunk(
    "get/user",
    async (id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("user?id=" + id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const addUser = createAsyncThunk(
    "post/User",
    async (param: any, thunkAPI) => {
        setToken();
        const data = {
            adminId: param.adminId,
            name: param.name,
            email: param.email,
            phone: param.phone,
            token: param.token,
            rights: param.rights,
        };
        try {
            return await axios.post("user", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const updUser = createAsyncThunk(
    "put/User",
    async (param: any, thunkAPI) => {
        setToken();
        const data = {
            adminId: param.adminId,
            id: param.id,
            name: param.name,
            email: param.email,
            phone: param.phone,
            rights: param.rights,
            oldPass: param.oldPass,
            passwd: param.passwd,
            token: param.token,
            news_info: param.newsInfo 
        };
        try {
            return await axios.put("user", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const renewToken = createAsyncThunk(
    "put/renewToken",
    async (id: string, thunkAPI) => {
        setToken();
        const data = {user_id: id};
        try {
            return await axios.put("renewToken", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const delUser = createAsyncThunk(
    "delete/User",
    async (param: any, thunkAPI) => {
        setToken();
        try {
            return await axios.delete("user?adminId=" + param.adminId + "&id=" + param.id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getMusicIndex = createAsyncThunk(
    "get/musicIndex",
    async (_: any, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getPlayLists = createAsyncThunk(
    "get/playList",
    async (_: any, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getPlayList = createAsyncThunk(
    "get/playList",
    async (file: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/" + file);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getPlayListDB = createAsyncThunk(
    "get/playListDB",
    async (id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data?playlist=" + id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const postPlayListDB = createAsyncThunk(
    "put/playListDB",
    async (param: {id: string, list: string[], name: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.put("cloud/music/data?playlist=" + param.id, {list: param.list, name: param.name});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const putPlayListDB = createAsyncThunk(
    "put/playListDB",
    async (param: {id: string, list: string[], name: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.put("cloud/music/data?playlist=" + param.id, {list: param.list, name: param.name});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getMediaTitles = createAsyncThunk(
    "get/mediaTitels",
    async (search: {pattern?: string, field: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data?" + search.field + "=" + search.pattern);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getMediaTitlelsLong = createAsyncThunk(
    "get/mediaTitelsLong",
    async (id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data?full=1&titleId=" + id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getMediaGroups = createAsyncThunk(
    "get/mediaGroups",
    async (search: {pattern: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data?group=" + search.pattern);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const addMediaTrack = createAsyncThunk(
    "post/addMediaTrack",
    async (p: ITitleLong, thunkAPI) => {
        setToken();
        // // const FormData = require("form-data");
        const data = new FormData();
        data.append("uploadfile", p.file);
        data.append("title", p.title);
        data.append("group", p.group) ;
        data.append("group_id", p.groupId ? p.groupId : "0");
        // data.append("duration", 0);
        try {
            return await axios.post("cloud/music/data", data, {headers: {'content-type': 'multipart/form-data'}});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const postMediaGroup = createAsyncThunk(
    "post/postMediaGroup",
    async (group: string, thunkAPI) => {
        setToken();
        try {
            return await axios.post("cloud/music/data?group=" + group);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const putMediaGroup = createAsyncThunk(
    "put/putMediaGroup",
    async (p: {group: string, groupId: string}, thunkAPI) => {
        setToken();
        try {
            return await axios.put("cloud/music/data", {group: p.group, group_id: p.groupId});
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const updateMediaTrack = createAsyncThunk(
    "put/updateMediaTrack",
    async (param: ITitle, thunkAPI) => {
        setToken();
        const title = {
            id: param.id,
            title: param.title,
            group_id: param.groupId,
            duration: param.time,
        };
        try {
            return await axios.put("cloud/music/data", title);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const delMediaTrack = createAsyncThunk(
    "delete/delMediaTrack",
    async (id: string, thunkAPI) => {
        setToken();
        try {
            return await axios.delete("cloud/music/data?title_id=" + id);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const delMediaGroup = createAsyncThunk(
    "delete/delMediaGroup",
    async (groupId: string, thunkAPI) => {
        setToken();
        try {
            return await axios.delete("cloud/music/data?group_id=" + groupId);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getChartLists = createAsyncThunk(
    "get/getChartLists",
    async (_: any, thunkAPI) => {
        setToken();
        try {
            return await axios.get("cloud/music/data?chartLists=1");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getTasks = createAsyncThunk(
    "get/timelog",
    async (userId: number, thunkAPI) => {
        setToken();
        try {
            return await axios.get("timelog?user_id=" + userId);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const logTime = createAsyncThunk(
    "post/logTime",
    async (taskId: string, thunkAPI) => {
        setToken();
        try {
            return await axios.post("logTime?task_id=" + taskId);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const newTask = createAsyncThunk(
    "post/newTask",
    async (task: ITask, thunkAPI) => {
        setToken();
        // const FormData = require("form-data");
        const data = new FormData();
        data.append("task", task.task);
        data.append("org_id", task.orgId);
        data.append("usr_id", task.usrId);
        try {
            return await axios.post("task", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getOrganizations = createAsyncThunk(
    "get/getOrganizations",
    async (_: number, thunkAPI) => {
        setToken();
        try {
            return await axios.get("timelog/organization");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const getPicIndex = createAsyncThunk(
    "get/picIndex",
    async (path: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("picindex?path=" + path);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

/* Chat */
export const getThreads = createAsyncThunk(
    "get/getThread",
    async (userId: string, thunkAPI) => {
        setToken();
        try {
            return await axios.get("getThreads?user_id=" + userId);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const createThread = createAsyncThunk(
    "post/addThread",
    async (thread: IThreadShort, thunkAPI) => {
        setToken();
        const data = new FormData();
        data.append("name", thread.name);
        data.append("members", thread.members.map((m: IMember) => {return String(m.userId) + ":" + (m.admin ? "1" : "0"); }).join(','));
        try {
            return await axios.post("addThread", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const updateThread = createAsyncThunk(
    "put/updThread",
    async (thread: IThreadShort, thunkAPI) => {
        setToken();
        const converted = {...thread, members: thread.members?.map((m: IMember) => {return String(m.userId) + ":" + (m.admin ? "1" : "0"); }).join(',')};
        try {
            return await axios.put("updThread", converted);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});

export const deleteThread = createAsyncThunk(
    "delete/deleteThread",
    async (threadId: number, thunkAPI) => {
        setToken();
        try {
            return await axios.delete("delThread?threadId=" + threadId);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const getMessageByDay = createAsyncThunk(
    "get/getMessages",
    async (param: {threadId: number; date: string}, thunkAPI) => {
        setToken();
        const url = "getMessages?threadId=" + param.threadId + (param.date ? "&date=" + param.date : "");
        try {
            return await axios.get(url);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});
export const addMessage = createAsyncThunk(
    "post/addMessage",
    async (param: {id: string, threadId: number, message: string}, thunkAPI) => {
        setToken();
        const data = new FormData();
        data.append("id", param.id);
        data.append("threadId", "" + param.threadId);
        data.append("message", param.message);
        try {
            return await axios.post("addMessage", data);
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        } 
});

export const getHello = createAsyncThunk(
    "get/getHello",
    async (_param: any, thunkAPI) => {
        try {
            return await axios.get("/hello");
        } catch (error) { 
            return thunkAPI.rejectWithValue({error});
        }
});